import React, { Fragment } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Tegel from "../overzicht/parts/Tegel";
import Row from "../../common/Row";
import Col from "../../common/Col";
import Button from "../../common/Button";
import DatePicker from "../../common/DatePickerVTT";
import SelectInput from "../../common/SelectInput";


const OverzichtForm = (props) => {
    const {
        model,
        onMeerTochten,
        provincies,
        tochtTypes,
        lusTypes,
        onChange,
        onSearch,
        errors,
    } = props;

    function tochtTegels() {
        return model.tochten.map((tocht, i) => {
            return (<Tegel
                key={i}
                naam={tocht.naam}
                datum={tocht.datum}
                adres={tocht.startplaatsStraatEnNummer}
                gemeente={(tocht.startplaatsPostcode ? tocht.startplaatsPostcode + " " : "") + tocht.startgemeenteNaam}
                organisator={tocht.organisatorNaam}
                logo={tocht.logo}
                isErkend={tocht.isErkend}
                toegankelijkheidGSporters={tocht.toegankelijkheidGSporters}
                toegankelijkheidVoorKinderen={tocht.toegankelijkheidVoorKinderen}
                afstanden={tocht.afstanden}
                tochtId={tocht.id}
                tochtTypeId={tocht.tochtTypeId}
                tochtTypeNaam={tocht.tochtTypeNaam}
            />);
        });
    }

    const tegels = tochtTegels();

    const laadMeer = model.filter.pageNumber < model.totalPages ?
        <Row>
            <div className="o-col-12">
                <div className="o-col-4">&nbsp;</div>
                <div className="o-col-4">
                    <Button
                        className="o-col-4"
                        onClick={onMeerTochten}
                        text="Laad meer"
                        style={{ width: '75%' }}
                    />
                </div>
            </div>
        </Row> : null;

    const tochtTypeItems = tochtTypes.map(tochtType => ({ value: tochtType.id, label: tochtType.naam }));
    const lusTypeItems = model.filter.tochtTypeId
        ? lusTypes.filter(lusType => lusType.tochtTypeId === model.filter.tochtTypeId).map(lusType => ({ value: lusType.id, label: lusType.naam }))
        : [];

    const vandaag = moment().startOf("day").toDate();

	return (
        <Fragment>
            <div className="c-section c-section--fiche sportdbpublic-fiche-section">
                <header className="c-section__header">
                    <h3 className="title">
                        Ik zoek
                    </h3>
                </header>
                <div className="c-section__body">
                        <Row>
                            <div className="c-filterOverzichtZoek">
                                <Col size={2}>
                                    <SelectInput
                                        name="tochtTypeId"
                                        defaultItem="Alle types"
                                        onChange={onChange}
                                        items={tochtTypeItems}
                                        value={model.filter.tochtTypeId}
                                    />
                                </Col>
                                <Col size={2}>
                                    <SelectInput
                                        name="lusTypeId"
                                        defaultItem="Alle subtypes"
                                        onChange={onChange}
                                        items={lusTypeItems}
                                        value={model.filter.lusTypeId}
                                        disabled={lusTypeItems.length === 0}
                                    />
                                </Col>
                                <Col size={3}>
                                    <SelectInput
                                        name="provincieId"
                                        defaultItem="Alle Vlaamse provincies"
                                        onChange={onChange}
                                        items={provincies}
                                        value={model.filter.provincieId}
                                        validationMessage={errors ? errors['provincieId'] : ""}
                                    />
                                </Col>
                                <Col size={4}>
                                    <Col size={6}>
                                        <DatePicker zIndex name="startDatum" onChange={onChange} id="startDatum" value={model.filter.startDatum} minDate={vandaag} placeholderText="Periode van" validationMessage={errors ? errors['startDatum'] : ""} />
                                    </Col>
                                    <Col size={6}>
                                        <DatePicker zIndex name="eindDatum" onChange={onChange} id="eindDatum" value={model.filter.eindDatum} minDate={model.filter.startDatum ? new Date(model.filter.startDatum) : vandaag} placeholderText="Periode tot" validationMessage={errors ? errors['eindDatum'] : ""} />
                                    </Col>
                                </Col>
                                <Col size={1}>
                                    <Button
                                        onClick={onSearch}
                                        text="Zoek"
                                    />
                                </Col>
                            </div>
                        </Row>
                    </div>
            </div>

            <div className="c-section c-section--fiche sportdbpublic-fiche-section">
                <header className="c-section__header">
                    <h3 className="title">
                        Lijst van tochten - {model.totaalAantalTochten} resultaten
                    </h3>
                </header>
                <div className="c-section__body">
                    <div className="c-content-block infrastructuur-fiche-block">
                        <div className="c-fiche-wrap">
                            {tegels}
                        </div>
                    </div>
                </div>
                {laadMeer}
            </div>
        </Fragment >);
};

OverzichtForm.propTypes = {
    model: PropTypes.object,
    onMeerTochten: PropTypes.func.isRequired,
    provincies: PropTypes.array.isRequired,
    tochtTypes: PropTypes.array.isRequired,
    lusTypes: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    errors: PropTypes.object,
};

export default OverzichtForm;
